import { render, staticRenderFns } from "./BeEntrepreneurshipView.vue?vue&type=template&id=2fc40b09&scoped=true&"
import script from "./BeEntrepreneurshipView.vue?vue&type=script&lang=js&"
export * from "./BeEntrepreneurshipView.vue?vue&type=script&lang=js&"
import style0 from "./BeEntrepreneurshipView.vue?vue&type=style&index=0&id=2fc40b09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc40b09",
  null
  
)

export default component.exports